import { createAction } from "redux-actions";

export const SET_MODAL_STATUS = "SET_MODAL_STATUS";
export const setModalStatusAction = createAction(SET_MODAL_STATUS);
